import { renameSessionWorktreeBranches } from '../../rename-session-worktree-branches.js';
import type { SessionWorktreeCache } from '../session-worktree-cache.js';

export async function renameSessionWorktreeBranch(
  cache: SessionWorktreeCache,
  sessionId: string,
  newBranch: string,
  log: (msg: string) => void,
): Promise<void> {
  const paths = cache.getRepoCheckoutPathsRef(sessionId);
  if (!paths?.length) return;
  await renameSessionWorktreeBranches(paths, newBranch, log);
}
